import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { ChannelSettingsComponent } from 'app/pages/ChannelSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_CALENDAR } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useCalendarConfigurationPage } from './hooks/useCalendarConfigurationPage';

const CalendarConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useCalendarConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Calendar configuration</title>
        <meta
          name="description"
          content="Configure channel settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Channel settings"
        headerSubtitle={
          hasDealer ? (
            <Typography variant="subtitle1" color="text.secondary">
              {dealerTitle ? `${dealerTitle} (${dealerId})` : dealerId}
            </Typography>
          ) : undefined
        }
        contentVariant="centered"
      >
        <ChannelSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  CalendarConfigurationPage,
  CONFIGURE_RESOURCE_CALENDAR,
);
